const TYPE = 'em8500';
const HISTORY_SIZE = 20;

export {
	TYPE,
	HISTORY_SIZE
}
